import React, { useState , useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate , useLocation } from "react-router-dom";
import { FaFileInvoice, FaCoffee,FaGasPump,FaMoneyBillWave, FaHome, FaBus, FaBolt, FaTag,FaPlusCircle,FaTrash,FaWallet,FaHistory, FaSave,FaPrint,} from "react-icons/fa";
import { showSuccess, showError, showWarning } from "../../General/Toast";
import axios from 'axios'
import "../../App.css"
const ExpensePage = ({clientData , role}) => {
  const navigate = useNavigate();

const location = useLocation();
const editData = location.state;
console.log(editData)

  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [categoryName, setCategoryName] = useState("");
    const [selectedCategory, setSelectedCategory] = useState(""); 
const [expenseNo, setExpenseNo] = useState(clientData?.expense_no || "");

const[bankList,setBankList] = useState([]);
const [selectedBankId, setSelectedBankId] = useState(0);
const [apiCategories, setApiCategories] = useState([]);
  const [items, setItems] = useState([
    {
      name: "",
      qty: 1,
      price: 0,
      tax: "None",
       amount: 0,
    },
  ]);

  //  const [formData, setFormData] = useState({
  //   payment_method:'',
  //   client_id: '',
  //   description:'',
  //   date:'',
  //   mode:'',
  //   cb_payid:'',
  //   paid:'',
  //   client_type:'',
  //     category: "",
  // });
const getCurrentDateTime = () => {
  const now = new Date();

  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60 * 1000);

  return localDate.toISOString().slice(0, 16);
};

const [formData, setFormData] = useState({
  payment_method: '',
  client_id: '',
  description: '',
  date: getCurrentDateTime(),
  mode: '',
  cb_payid: '',
  paid: '',
  client_type: '',
  category: "",
});
  const isEditMode = Boolean(editData);



useEffect(() => {
  if (editData) {
    setFormData({
      payment_method: editData.mode || "",
      client_id: editData.client_id || "",
      description: editData.description || "",
      date: editData.date || "",
      mode: editData.mode || "",
      cb_payid: editData.cb_payid || "",
      paid: editData.paid || "",
      client_type: editData.client_type || "",
      category: editData.category || "",
    });

    setSelectedCategory(editData.category || "");
    setExpenseNo(editData.invoiceNo || "");

    if (editData.items) {
      const parsed =
        typeof editData.items === "string"
          ? JSON.parse(editData.items)
          : editData.items;

      const formattedItems = parsed.map((item) => ({
        name: item.name || "",
        qty: Number(item.quant || 0),
        price: Number(item.price_per_unit || 0),
        tax: item.tax || "None",
        amount: Number(item.amount || 0),
      }));

      setItems(formattedItems);
    }

    setSelectedBankId(editData.cb_payid || 0);
  }
}, [editData]);



  const [invoiceDate, setInvoiceDate] = useState(
    new Date().toISOString().split("T")[0]
  );

const handleItemChange = (index, field, value) => {
  const updatedItems = [...items];

  updatedItems[index][field] = value;

  const qty = Number(updatedItems[index].qty) || 0;
  const price = Number(updatedItems[index].price) || 0;

  let subtotal = qty * price;

  let taxPercent = 0;

  if (updatedItems[index].tax.includes("18")) {
    taxPercent = 18;
  }

  const taxAmount = (subtotal * taxPercent) / 100;

  updatedItems[index].amount = subtotal + taxAmount;

  setItems(updatedItems);
};

const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      return updated;
    });
  };


  const addItem = () => {
    setItems([
      ...items,
      {
        name: "",
        qty: 1,
        price: 0,
        tax: "None",
      },
    ]);
  };

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };




  const totalQty = items.reduce(
  (sum, item) => sum + Number(item.qty || 0),
  0
);

const totalRate = items.reduce(
  (sum, item) => sum + Number(item.price || 0),
  0
);

const grandTotal = items.reduce(
  (sum, item) => sum + Number(item.amount || 0),
  0
);

const totalTax = items.reduce((sum, item) => {
  const subtotal = item.qty * item.price;

  let taxPercent = item.tax.includes("18") ? 18 : 0;

  return sum + (subtotal * taxPercent) / 100;
}, 0);


const fetchbankAccount = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-bank-accounts/${clientData.id}`
    );

    const data =
      typeof res.data === "string"
        ? JSON.parse(res.data)
        : res.data;

    // Always keep bankList as an array
    setBankList(Array.isArray(data) ? data : []);

  } catch (error) {
    console.error("Fetch bank account error:", error);
    setBankList([]);
  }
};
// const fetchCategories = async () => {
//   try {
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-expcat/${clientData.id}`
//     );

//     const data =
//       typeof res.data === "string"
//         ? JSON.parse(res.data)
//         : res.data;

//     const formatted = (Array.isArray(data) ? data : []).map((item) => ({
//       icon: <FaTag />,
//       name: item.cat_name,
//       bg: "#f2ebff",
//     }));

//     setApiCategories(formatted);

//   } catch (error) {
//     console.error("Fetch categories error:", error);
//     setApiCategories([]);
//   }
// };


// const fetchCategories = async () => {
//   try {
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-expcat/${clientData.id}`
//     );

//     const formatted = res.data.map((item) => ({
//       icon: <FaTag />, // default icon for API categories
//       name: item.cat_name,
//       bg: "#f2ebff",
//     }));

//     setApiCategories(formatted);

//   } catch (error) {
//     console.error(error);
//   }
// };
const fetchCategories = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-expcat/${clientData.id}`
    );

    const data =
      typeof res.data === "string"
        ? JSON.parse(res.data)
        : res.data;

    const formatted = (Array.isArray(data) ? data : []).map((item) => ({
      icon: <FaTag />,
      name: item.cat_name,
      bg: "#f2ebff",
    }));

    setApiCategories(formatted);
  } catch (error) {
    console.error("Fetch categories error:", error);
    setApiCategories([]);
  }
};
  useEffect(() => {
   fetchbankAccount();
     fetchCategories();
  }, []);

  const allCategories = [ ...apiCategories];


const handleCreateExpense = async () => {
  try {
    const expenseItems = items.map((item, index) => ({
      SNo: String(index + 1),
      name: item.name,
      quant: String(item.qty),
      price_per_unit: String(item.price),
      tax: item.tax,
      amount: Number(item.amount || 0).toFixed(2),
    }));

    const payload = {
      invoiceNo: expenseNo,
      date: formData.date,
      items: expenseItems,
      description: formData.description,
      category: selectedCategory,
      mode: formData.payment_method,
      paid: Number(grandTotal || 0),
      client_type: role || "",
      cb_payid:
        formData.payment_method === "Cash"
          ? 0
          : Number(selectedBankId || 0),
    };

    console.log("Expense Save Payload:", payload);

    // Save expense bill
    const res = await axios.post(
      `https://api.dectwinbilling.com/expense-bill/${clientData.id}`,
      payload
    );

    if (res.status === 200) {
      // Generate next expense number
      const nextExpenseNo = Number(expenseNo) + 1;

      await axios.put(
        `https://api.dectwinbilling.com/update-expense-no/${clientData.id}`,
        {
          expense_no: nextExpenseNo,
        }
      );

      setExpenseNo(nextExpenseNo);

      // Update local storage
      localStorage.setItem(
        "user_data",
        JSON.stringify({
          ...clientData,
          expense_no: nextExpenseNo,
        })
      );

      // Cash / Bank entry
      const entryPayload = {
        client_id: clientData.id,
        adj_on: new Date(),
        adj_type: "Reduce",
        amount: Number(grandTotal || 0),
        description: `Expense Payment - ${expenseNo}`,
        c_type: "Expense",
        invoiceNo: expenseNo,
      };

      if (formData.payment_method !== "Cash") {
        await axios.post(
          "https://api.dectwinbilling.com/account-entry",
          {
            ...entryPayload,
            account_id: Number(selectedBankId || 0),
          }
        );
      } else {
        await axios.post(
          "https://api.dectwinbilling.com/cash-entry",
          entryPayload
        );
      }

      // showSuccess("Expense Added Successfully", "success");

      // resetForm();
      showSuccess("Expense Added Successfully", "success");

printExpenseBill({
  expenseNo: expenseNo,
  date: formData.date,
  category: selectedCategory,
  paymentMethod: formData.payment_method,
  description: formData.description,
  items: items,
  total: grandTotal,
  clientName: clientData?.name || "TESTING ACCOUNT",
});

resetForm();
    }
  } catch (error) {
    console.error("Save Expense Error:", error);

    showError(
      error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to save expense",
      "error"
    );
  }
};


const handleUpdateExpense = async () => {
  const expenseItems = items.map((item, index) => ({
    SNo: String(index + 1),
    name: item.name,
    quant: String(item.qty),
    price_per_unit: String(item.price),
    tax: item.tax,
    amount: item.amount.toFixed(2),
  }));

  const payload = {
    invoiceNo: expenseNo,
    date: formData.date,
    items: expenseItems,
    description: formData.description,
    category: selectedCategory,
    mode: formData.payment_method,
    paid: grandTotal,
    client_type: role || "",
    cb_payid: formData.payment_method === "Cash" ? 0 : selectedBankId,
  };

  const res = await axios.put(
    `https://api.dectwinbilling.com/update-expense-bill/${clientData.id}`,
    payload
  );

  showSuccess("Expense Updated Successfully", "success");
  resetForm();
  navigate("/expenseshistory");
};


const handleSubmit = async () => {
  try {
    if (!selectedCategory) {
      return showWarning("Select category");
    }

    if (!formData.date) {
      return showWarning("Select date");
    }

    if (!formData.payment_method) {
      return showWarning("Select payment method");
    }

    // ✅ Expense amount must be greater than 0
    if (Number(grandTotal) <= 0) {
      return showWarning("Expense Amount should be greater than 0 (Zero)");
    }

    if (isEditMode) {
      await handleUpdateExpense();
    } else {
      await handleCreateExpense();
    }
  } catch (error) {
    console.log(error);
    showError("Something went wrong");
  }
};

// const handleSubmit = async () => {
//   try {
//     if (!selectedCategory) return showWarning("Select category");
//     if (!formData.date) return showWarning("Select date");
//     if (!formData.payment_method) {
//       return showWarning("Select payment method");
//     }

//     if (isEditMode) {
//       await handleUpdateExpense();
//     } else {
//       await handleCreateExpense();
//     }
//   } catch (error) {
//     console.log(error);
//     showError("Something went wrong");
//   }
// };
const resetForm = () => {
  setFormData({
    payment_method: "",
    client_id: "",
    description: "",
    date: getCurrentDateTime(),
    mode: "",
    cb_payid: "",
    paid: "",
    client_type: "",
    category: "",
  });

  setSelectedCategory("");
  setSelectedBankId("");

  setItems([
    {
      name: "",
      qty: 1,
      price: 0,
      tax: "None",
      amount: 0,
    },
  ]);
};
// const resetForm = () => {

//   setFormData({
//     payment_method: "",
//     client_id: "",
//     description: "",
//     date: "",
//     mode: "",
//     cb_payid: "",
//     paid: "",
//     client_type: "",
//     category: "",
//   });

//   setSelectedCategory("");

//   setSelectedBankId("");



//   setItems([
//     {
//       name: "",
//       qty: 1,
//       price: 0,
//       tax: "None",
//       amount: 0,
//     },
//   ]);
// };
const printExpenseBill = ({
  expenseNo,
  date,
  category,
  paymentMethod,
  description,
  items,
  total,
  clientName,
}) => {
  const formatDate = (value) => {
    if (!value) return "";

    const d = new Date(value);

    if (isNaN(d.getTime())) {
      return value;
    }

    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const itemRows = items
    .map(
      (item, index) => `
        <tr>
          <td>${index + 1}</td>
          <td>${item.name || "-"}</td>
          <td>${Number(item.qty || 0)}</td>
          <td>₹ ${Number(item.price || 0).toFixed(2)}</td>
          <td>${item.tax || "-"}</td>
          <td>₹ ${Number(item.amount || 0).toFixed(2)}</td>
        </tr>
      `
    )
    .join("");

  const printWindow = window.open(
    "",
    "_blank",
    "width=900,height=900"
  );

  if (!printWindow) {
    alert("Please allow popup for printing.");
    return;
  }

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Expense Bill - ${expenseNo}</title>

      <style>
        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          padding: 25px;
          font-family: Arial, Helvetica, sans-serif;
          color: #111;
          background: #fff;
        }

        .bill {
          width: 100%;
          max-width: 800px;
          margin: 0 auto;
          border: 1px solid #222;
          padding: 28px;
        }

        .header {
          text-align: center;
          border-bottom: 2px solid #111;
          padding-bottom: 18px;
          margin-bottom: 20px;
        }

        .header h1 {
          margin: 0;
          font-size: 26px;
          letter-spacing: 1px;
        }

        .header h2 {
          margin: 7px 0;
          font-size: 18px;
        }

        .header p {
          margin: 0;
          font-size: 12px;
          color: #555;
        }

        .details {
          display: grid;
          grid-template-columns: 1fr 1fr;
          border: 1px solid #ccc;
          margin-bottom: 22px;
        }

        .detail {
          padding: 12px 15px;
          border-bottom: 1px solid #ddd;
        }

        .detail:nth-child(odd) {
          border-right: 1px solid #ddd;
        }

        .label {
          display: block;
          font-size: 11px;
          color: #666;
          margin-bottom: 5px;
          text-transform: uppercase;
        }

        .value {
          font-size: 14px;
          font-weight: 600;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th {
          background: #111;
          color: #fff;
          padding: 10px 8px;
          font-size: 12px;
          text-align: left;
        }

        td {
          border: 1px solid #ccc;
          padding: 10px 8px;
          font-size: 12px;
        }

        th:first-child,
        td:first-child {
          width: 55px;
          text-align: center;
        }

        th:nth-child(3),
        td:nth-child(3) {
          width: 65px;
          text-align: center;
        }

        th:nth-child(4),
        td:nth-child(4),
        th:nth-child(6),
        td:nth-child(6) {
          text-align: right;
        }

        .total-box {
          width: 320px;
          margin-left: auto;
          margin-top: 20px;
          border: 1px solid #ccc;
        }

        .total-row {
          display: flex;
          justify-content: space-between;
          padding: 11px 14px;
          border-bottom: 1px solid #ddd;
          font-size: 13px;
        }

        .total-row:last-child {
          border-bottom: none;
        }

        .grand-total {
          background: #f1f1f1;
          font-size: 17px;
          font-weight: bold;
        }

        .description {
          margin-top: 20px;
          padding: 12px;
          border: 1px solid #ccc;
          font-size: 13px;
        }

        .footer {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-top: 60px;
          font-size: 12px;
        }

        .signature {
          width: 180px;
          text-align: center;
          border-top: 1px solid #222;
          padding-top: 8px;
        }

        @page {
          size: A4;
          margin: 12mm;
        }

        @media print {
          body {
            padding: 0;
          }

          .bill {
            max-width: none;
          }
        }
      </style>
    </head>

    <body>

      <div class="bill">

        <div class="header">
          <h1>EXPENSE BILL</h1>
          <h2>${clientName || "TESTING ACCOUNT"}</h2>
          <p>Expense Payment Receipt</p>
        </div>

        <div class="details">

          <div class="detail">
            <span class="label">Expense For</span>
            <span class="value">
              ${category || "-"}
            </span>
          </div>

          <div class="detail">
            <span class="label">Expense No.</span>
            <span class="value">
              ${expenseNo || "-"}
            </span>
          </div>

          <div class="detail">
            <span class="label">Date</span>
            <span class="value">
              ${formatDate(date)}
            </span>
          </div>

          <div class="detail">
            <span class="label">Payment Mode</span>
            <span class="value">
              ${paymentMethod || "-"}
            </span>
          </div>

        </div>

        <table>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Item Name</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>Tax</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            ${itemRows}
          </tbody>
        </table>

        <div class="total-box">

          <div class="total-row">
            <span>Total Items</span>
            <strong>${items.length}</strong>
          </div>

          <div class="total-row grand-total">
            <span>Total Amount</span>
            <strong>
              ₹ ${Number(total || 0).toFixed(2)}
            </strong>
          </div>

        </div>

        ${
          description
            ? `
              <div class="description">
                <strong>Description</strong>
                <br />
                ${description}
              </div>
            `
            : ""
        }

        <div class="footer">

          <div>
            <strong>Thank you</strong>
            <br />
            Computer generated expense bill.
          </div>

          <div class="signature">
            Authorized Signature
          </div>

        </div>

      </div>

      <script>
        window.onload = function () {
          window.focus();
          window.print();
        };

        window.onafterprint = function () {
          window.close();
        };
      </script>

    </body>
    </html>
  `);

  printWindow.document.close();
};

const handleAddCategory = async () => {
  try {
    if (!categoryName.trim()) {
      alert("Please enter category name");
      return;
    }

    const payload = {
      cat_name: categoryName,
      cat_type: "ExpCat",
      client_id: clientData.id,
    };

    const response = await axios.post("https://api.dectwinbilling.com/add-category", payload);
    showSuccess(response.data.message,'success');

    fetchCategories(); 


    setCategoryName("");
    setShowCategoryModal(false);

  } catch (error) {
    console.error(error);

    showError(
      error?.response?.data?.message ||
      "Failed to add category","error"
    );
  }
};

const paymentMethod = formData.payment_method || editData?.mode;

  return (
    <div
      className="container-fluid py-2 py-md-3 px-2 px-md-3"
      style={{
        background: "#edf0ff",
        minHeight: "100vh",
      }}
    >
      <div className="row">

        <div className="col-12 col-lg-10">
          <div className="card border-0 shadow-sm rounded-4 p-4">

            <div className="d-flex align-items-center p-2" style={{backgroundColor:"var(--table-header)"}}>
              <div
                className="me-3 d-flex align-items-center justify-content-center"
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  background: "#6f52ed",
                  color: "#fff",
                }}
              >
                <FaFileInvoice />
              </div>

              <div >
                <h3 className="fw-bold mb-0">Add Expense</h3>

              </div>
            </div>

<div className="row g-3 mb-4">


  <div className="col-lg-4">
    <div className="rounded-3 p-3 h-100 mt-2">
      <textarea
        className="form-control"
        rows="5"
        placeholder="Enter expense description"
        style={{ resize: "none" }}
          name="description"
          value={formData.description}
 onChange={handleInputChange}
      />
      
    </div>
  </div>


 <div className="col-lg-4">
  </div>


  {/* RIGHT SIDE - INVOICE CARD */}
  <div className="col-lg-4 mt-4">
    <div className="border rounded-3 p-3  mt-2" style={{backgroundColor:"var(--card-color)"}}>

      <div className="d-flex align-items-center gap-3 mb-3">

  <small
    className="text-dark mb-0"
    style={{ width: "120px" }}
  >
    Expense No
  </small>

  <input
    type="text"
    className="form-control rounded-3"
    value={expenseNo}
    readOnly
  />

</div>


<div className="d-flex align-items-center gap-3">

  <small
    className="text-dark mb-0"
    style={{ width: "120px" }}
  >
    Invoice Date
  </small>

  <input
    type="datetime-local"
    className="form-control"
    name="date"
     value={formData.date}
   onChange={handleInputChange}
  />

</div>

    </div>
  </div>

</div>


            <div
              className="mb-4"
              style={{
                border: "1px solid #e8e8e8",
                borderRadius: "12px",
                overflow: "hidden",
                background: "#fff",
              }}
            >

              <div className="table-responsive">
                <table className="table align-middle mb-0 text-center">
                  <thead>
                    <tr>
                      <th style={{ backgroundColor:"var(--primary-color)", color: "#fff" }}>
                        S.No.
                      </th>
                      <th style={{ backgroundColor:"var(--primary-color)", color: "#fff" }}>
                        Item Name
                      </th>
                      <th style={{ backgroundColor:"var(--primary-color)", color: "#fff" }}>
                        Quantity
                      </th>
                      <th style={{ backgroundColor:"var(--primary-color)", color: "#fff" }}>
                        Price / Unit
                      </th>
                      <th style={{ backgroundColor:"var(--primary-color)", color: "#fff" }}>
                        Tax
                      </th>
                      <th style={{ backgroundColor:"var(--primary-color)", color: "#fff" }}>
                        Amount
                      </th>
                      <th style={{ backgroundColor:"var(--primary-color)", color: "#fff" }}></th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>

                        <td>
                         <input
  className="form-control border-0"
  value={item.name}
  onChange={(e) =>
    handleItemChange(index, "name", e.target.value)
  }
/>
                        </td>

                        <td>
                         <input
  type="number"
  className="form-control border-0 text-center"
  value={item.qty}
  onChange={(e) =>
    handleItemChange(index, "qty", e.target.value)
  }
/>
                        </td>

                        <td>
                          <input
  type="number"
  className="form-control border-0 text-center"
  value={item.price}
  onChange={(e) =>
    handleItemChange(index, "price", e.target.value)
  }
/>
                        </td>

                        <td>
                         <select
  className="form-select border-0"
  value={item.tax}
  onChange={(e) =>
    handleItemChange(index, "tax", e.target.value)
  }
>
  <option value="None">None</option>
  <option value="GST 0%">GST 0%</option>
  <option value="GST 18%">GST 18%</option>
  <option value="IGST 18%">IGST 18%</option>
  <option value="CGST 18%">CGST 18%</option>
</select>
                        </td>

                       {/* <td>₹ {item.amount.toFixed(2)}</td> */}
                       <td>₹ {Number(item.amount || 0).toFixed(2)}</td>

                        <td>
                          <FaTrash
                            style={{
                              color: "#dc3545",
                              cursor: "pointer",
                            }}
                            onClick={() => removeItem(index)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>


              <div className="p-3">
                <div
                  className="text-center py-3 rounded-3"
                  style={{
                    border: "1.5px dashed #c9b6ff",
                   color:"var(--primary-color)",
                    cursor: "pointer",
                    background: "#fcfbff",
                  }}
                  onClick={addItem}
                >
                  <FaPlusCircle className="me-2" />
                  Add Another Item
                </div>
              </div>
            </div>


    <div className="mb-4 border rounded-3 p-3 text-white" style={{backgroundColor:"var(--primary-color)"}}>

  <div className="row align-items-center">

    <div className="col-md-4">
      <div className="fw-semibold">Total</div>
    </div>

    <div className="col-md-2 text-end fw-semibold">
    </div>
     <div className="col-md-2 text-end fw-semibold">
    </div>
    <div className="col-md-2 text-end fw-semibold">
    ₹{totalTax.toFixed(2)}
    </div>


    <div className="col-md-2 text-end fw-bold">
    ₹{grandTotal.toFixed(2)}
    </div>

    <div className="col-md-4"></div>

  </div>

</div>

       <div className="row g-3">


  <div className="col-md-4">
{!isEditMode && (
    <div className="border rounded-4 p-3  h-100" style={{backgroundColor:"var(--card-color)"}}>

      <div className="fw-semibold mb-2">
        Payment Method
      </div>

      <select className="form-select" 
       name="payment_method"
                value={formData.payment_method}
       
                 onChange={(e) => {
    handleInputChange(e);

    if (e.target.value === "Cash") {
      setSelectedBankId(0);
    }
  }}
      >
        <option>Select payment method</option>
        <option value='Cash' >Cash</option>
        <option value='UPI'>UPI</option>
        <option value='Bank' >Bank</option>
        <option value='Card'>Card</option>
      </select>

    </div>
)}
  </div>


 
  <div className="col-md-4">
    {!isEditMode && paymentMethod && paymentMethod !== "Cash" && (
    <div className="mt-2">

      <div className="fw-bold mb-2">
        Select Bank Account
      </div>


<select
  className="form-select form-select-sm"
  value={selectedBankId || ""}

onChange={(e) => {
  const bankId = Number(e.target.value);

  setSelectedBankId(bankId);

  setFormData((prev) => ({
    ...prev,
    cb_payid: bankId,
  }));
}}
>
  <option value="">Select Bank</option>
{(Array.isArray(bankList) ? bankList : []).map((bank) => (
  <option key={bank.id} value={bank.id}>
    {bank.account_holder} ({bank.bank_name})
  </option>
))}
  {/* {bankList.map((bank) => (
    <option key={bank.id} value={bank.id}>
      {bank.account_holder} ({bank.bank_name})
    </option>
  ))} */}
</select>

    </div>
)}
  </div>

  <div className="col-md-4"  style={{backgroundColor:"var(--card-color)"}}>
    <div className="border rounded-5 p-2 bg-white  text-center text-md-end mt-1" >

     <div className="d-flex justify-content-between align-items-center " >
  
  <div className="text-muted fw-semibold">
    Total Amount
  </div>

  <h2 className="text-success fw-bold mb-0">
    ₹{grandTotal.toFixed(2)}
  </h2>

</div>

    </div>
  </div>

</div>

            <div className="d-flex flex-column flex-md-row justify-content-between gap-3 mt-4 p-2" style={{backgroundColor:"var(--table-header)"}} >
              <button
                className="btn btn-light btn-outline-secondary rounded-pill px-4"
                onClick={() => navigate("/expenseshistory")}
              >
                <FaHistory className="me-2" />
                Expense History
              </button>
              <div className="d-flex flex-column flex-sm-row gap-2">
                <button className="btn-credit btn-light border me-2 px-4" onClick={handleSubmit}>
                    {isEditMode ? "Update" : "Save"}
                </button>
{/* 
                <button
                  className="btn-credit text-white px-4"
                 
                >
                  <FaPrint className="me-2" onClick={handleSubmit} />
                  Save & Print
                </button> */}
                <button
  type="button"
  className="btn-credit text-white px-4"
  onClick={handleSubmit}
>
  <FaPrint className="me-2" />
  Save & Print
</button>
              </div>
            </div>
          </div>
        </div>


        <div className="col-12 col-lg-2 mt-3 mt-lg-0">
          <div className="card border-0 shadow-sm rounded-4 p-3 h-100"
          >

            <h6 className="fw-bold mb-3">
              <FaTag className="me-2 text-primary" />
              Categories
            </h6>



  {/* {apiCategories.map((cat, index) => (
  <div
    key={index}
    className="d-flex align-items-center mb-3 p-3 rounded-4"
    style={{
      background: cat.bg,
      cursor: "pointer",
      border:
        selectedCategory === cat.name
          ? "2px solid #6f42c1"
          : "2px solid transparent",
    }}
    onClick={() => {
      setSelectedCategory(cat.name);

      showSuccess("Category selected successfully", "success");

      setFormData((prev) => ({
        ...prev,
        category: cat.name,
      }));
    }}
  >
    <div className="me-3 fs-5">{cat.icon}</div>

    <small className="fw-semibold">{cat.name}</small>
  </div>
))} */}
{apiCategories.map((cat, index) => (
  <div
    key={index}
    className="d-flex align-items-center mb-3 p-3 rounded-4"
    style={{
      background: cat.bg,
      cursor: "pointer",
      border:
        selectedCategory === cat.name
          ? "2px solid #6f42c1"
          : "2px solid transparent",
    }}
    onClick={() => {
      setSelectedCategory(cat.name);

      setFormData((prev) => ({
        ...prev,
        category: cat.name,
      }));
    }}
  >
    <div className="me-3 fs-5">
      {cat.icon}
    </div>

    <small className="fw-semibold">
      {cat.name}
    </small>
  </div>
))}
            <button
              className="btn btn-outline-secondary w-100"
              onClick={() => setShowCategoryModal(true)}
            >
              + Add More Category
            </button>
            {showCategoryModal && (
              <>
                {/* Backdrop */}
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.3)",
                    zIndex: 999,
                  }}
                  onClick={() => setShowCategoryModal(false)}
                />

                {/* Modal */}
                <div
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: "340px",
                    background: "#ece7ef",
                    borderRadius: "0 25px 25px 25px",
                    padding: "25px",
                    zIndex: 1000,
                    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                  }}
                >
                  <h3 className="fw-bold mb-4">Add Category</h3>

                  <div
                    className="p-3 mb-4"
                    style={{
                      background: "#d7d3d5",
                      borderRadius: "15px",
                    }}
                  >
                    <label className="fw-bold">
                      Category Name :
                    </label>

                    <input
                      type="text"
                      className="border-0 bg-transparent ms-1"
                      placeholder="Enter Here"
                      value={categoryName}
                      onChange={(e) =>
                        setCategoryName(e.target.value)
                      }
                style={{
                        outline: "none",
                        width: "60%",
                      }}
                    />
                  </div>

                  <div className="d-flex justify-content-end gap-3">
                    <button
                      className="btn btn-light rounded-pill px-4"
                      onClick={() => setShowCategoryModal(false)}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-light rounded-pill px-4"
                        onClick={handleAddCategory}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpensePage;